$(document).ready(function() {
  // Hide all tab content initially except the first
  $('.tabs-content > li').hide();
  $('.tabs-content > li:first').show();

  // Replace tab headers with clickable accordion headers
  $('.tabs li a').each(function(index) {
    var $tabLink = $(this);
    var target = $tabLink.attr('href');
    var label = $tabLink.text().trim();

    // Insert accordion header before each content block
    $(target).before('<div class="accordion-header acc'+index+'" data-target="' + target + '">' + label + '<span>+</span></div>');
  });

  // Remove original tabs navigation
  $('.tabs').remove();

  // Accordion behavior
  $('.accordion-header').on('click', function() {
    var target = $(this).data('target');

    // Toggle the clicked section
    var $target = $(target);
    if ($target.is(':visible')) {
      $target.slideUp();
    } else {
      $('.tabs-content > li').slideUp();
      $target.slideDown();
    }
  });





});